import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/ContextoAuth';
import { useWorkspace } from '../contexts/ContextoWorkspace';
import { ROUTES } from '../utils/constants';
import { resolverRutaAuthNoAutenticado } from '../utils/authRedirect';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireWorkspace?: boolean;
}

export function ProtectedRoute({ children, requireWorkspace = true }: ProtectedRouteProps) {
  const { isAuthenticated, esCargando } = useAuth();
  const { hasContext } = useWorkspace();
  const location = useLocation();

  if (esCargando) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          <p className="mt-4 text-gray-600 dark:text-gray-400">Cargando...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={resolverRutaAuthNoAutenticado(location.pathname)} state={{ from: location }} replace />;
  }

  if (requireWorkspace && !hasContext) {
    return <Navigate to={ROUTES.PRIVATE.SELECT_WORKSPACE} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
